import { render, staticRenderFns } from "./my-license-plate-add.vue?vue&type=template&id=047fea20&"
import script from "./my-license-plate-add.vue?vue&type=script&lang=js&"
export * from "./my-license-plate-add.vue?vue&type=script&lang=js&"
import style0 from "./my-license-plate-add.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports